// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2R5PA","option":"styles_option__BONKh","active":"styles_active__2lv7U"};